var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarrierIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Barier") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Barier",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mbri-error",
    transform: "translate(11.000000, 11.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.514,3.55271368e-15 C0.064,3.55271368e-15 -0.174,0.54 0.151,0.857 L3.294,3.997 L0.148,7.143 C-0.307,7.579 0.403,8.32 0.855,7.85 L4,4.705 L7.146,7.85 C7.598,8.32 8.308,7.58 7.853,7.143 L4.707,3.998 L7.849,0.858 C8.173,0.54 7.936,0 7.485,0 C7.355,0.004 7.232,0.058 7.141,0.15 L4,3.29 L0.858,0.15 C0.768,0.058 0.644,0.004 0.514,1.77635684e-15 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mbri-layers",
    transform: "translate(3.000000, 3.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5,0 C0.678,0 0,0.678 0,1.5 L0,22.5 C0,23.322 0.678,24 1.5,24 L22.5,24 C23.322,24 24,23.322 24,22.5 L24,1.5 C24,0.678 23.322,0 22.5,0 L1.5,0 Z M1.5,1 L22.5,1 C22.786,1 23,1.214 23,1.5 L23,22.5 C23,22.786 22.786,23 22.5,23 L1.5,23 C1.214,23 1,22.786 1,22.5 L1,1.5 C1,1.214 1.214,1 1.5,1 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarrierIcon);
export default __webpack_public_path__ + "static/media/barrier-icon.20597b1c025991bb62158689d2aab491.svg";
export { ForwardRef as ReactComponent };